import { ICONBUTTON_ICON_SIZES, ICONBUTTON_PADDING_SIZES } from '../IconButton/IconButton.constants';
// Constants.
// -----------------------------------------------------------------------------
export const ICON_LINK_DEFAULT_MODE = 'light';
export const ICON_LINK_DEFAULT_SCHEMA = 'brand2';
export const ICON_LINK_DEFAULT_SIZE = 's';
export const ICON_LINK_DEFAULT_VARIANT = 'bare';
export const ICON_LINK_ICON_SIZES = ICONBUTTON_ICON_SIZES;
export const ICON_LINK_PADDING_SIZES = ICONBUTTON_PADDING_SIZES;
//# sourceMappingURL=IconLink.constants.js.map